import * as ActionTypes from './types';

export function deletePerson(payload) {
    return {
        type: ActionTypes.DELETE_PERSON,
        payload: payload
    }
}

export function deletePersonSuccess(payload) {
  return {
    type: ActionTypes.DELETE_PERSON_SUCCESS,
    payload: payload
  }
}

export function deletePersonFailed(payload) {
  return {
    type: ActionTypes.DELETE_PERSON_FAILED,
    payload: payload
  }
}

export function resetPassword(payload) {
    return {
        type: ActionTypes.RESET_PASSWORD,
        payload: payload
    }
}

export function resetPasswordSuccess(payload) {
  return {
    type: ActionTypes.RESET_PASSWORD_SUCCESS,
    payload: payload
  }
}

export function resetPasswordFailed(payload) {
  return {
    type: ActionTypes.RESET_PASSWORD_FAILED,
    payload: payload
  }
}

export function changePersonState(payload) {
    return {
        type: ActionTypes.CHANGE_PERSON_STATE,
        payload: payload
    }
}

export function updatePerson(payload) {
  return {
    type: ActionTypes.UPDATE_PERSON,
    payload: payload
  }
}

export function updatePersonSuccess(payload) {
  return {
    type: ActionTypes.UPDATE_PERSON_SUCCESS,
    payload: payload
  }
}

export function updatePersonFailed(payload) {
  return {
    type: ActionTypes.UPDATE_PERSON_FAILED,
    payload: payload
  }
}

export function getPersonById(payload) {
  return {
    type: ActionTypes.GET_PERSON_BY_ID,
    payload: payload
  }
}

export function getPersonByIdSuccess(payload) {
  return {
    type: ActionTypes.GET_PERSON_BY_ID_SUCCESS,
    payload: payload
  }
}

export function getPersonByIdFailed(payload) {
  return {
    type: ActionTypes.GET_PERSON_BY_ID_FAILED,
    payload: payload
  }
}

export function createPerson(payload) {
  return {
    type: ActionTypes.CREATE_PERSON,
    payload: payload
  }
}

export function createPersonSuccess(payload) {
  return {
    type: ActionTypes.CREATE_PERSON_SUCCESS,
    payload: payload
  }
}

export function createPersonFailed(payload) {
  return {
    type: ActionTypes.CREATE_PERSON_FAIL,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/person.js